import React from "react";
import theme from "../configuration/theme";
import {GlobalStyles, ScopedCssBaseline, ThemeProvider} from "@mui/material";
import { Provider as ReduxProvider } from 'react-redux';
import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import rootReducer from '../slices';


const store = configureStore({ reducer: rootReducer, middleware: getDefaultMiddleware({ serializableCheck: false }) });

const ThemeProviderWrapper = ({ children }) => {
    return <ReduxProvider store={store}>
        <ThemeProvider theme={theme}>
            <ScopedCssBaseline >
            <GlobalStyles styles={{
                "*, ::after, ::before": {
                    boxSizing: 'border-box',
                    '-webkit-tap-highlight-color': 'transparent'
                },
                button:{
                    width: 'auto',
                    height: 'auto',
                    "&:hover":{
                        border: 0,
                        color: 'inherit',
                        backgroundColor: 'inherit'
                    }
                },
                legend:{
                  border: 0
                },
                input:{
                  height: 'inherit !important',
                  boxSizing: 'inherit !important',
                    fontFamily: '"Visuelt Pro", Helvetica, Arial, Roboto, sans-serif !important'
                },
                'div:empty':{
                    display: 'inherit'
                },
                '*:focus-visible': {
                    outline: 'none'
                }}}/>
            {children}
            </ScopedCssBaseline>
        </ThemeProvider>
    </ReduxProvider>
}

export default ThemeProviderWrapper;